var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortfolio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 187.381,
    y: 174.186,
    style: {
      fill: "#E7ECED"
    },
    width: 137.237,
    height: 47.505
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 160.99,
    y: 15.835,
    style: {
      fill: "#A58763"
    },
    width: 190.021,
    height: 42.227
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A58763"
    },
    d: "M504.082,137.237v89.732h-5.278c-58.273,0-105.567-44.866-105.567-100.289h100.289 C499.332,126.68,504.082,131.431,504.082,137.237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A58763"
    },
    d: "M504.082,395.876v89.732c0,5.806-4.751,10.557-10.557,10.557H393.237 c0-55.423,47.294-100.289,105.567-100.289H504.082z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A58763"
    },
    d: "M113.485,496.165h-95.01c-5.806,0-10.557-4.751-10.557-10.557v-89.732 C66.191,395.876,113.485,440.742,113.485,496.165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A58763"
    },
    d: "M18.474,126.68h95.01c0,55.423-47.294,100.289-105.567,100.289v-89.732 C7.918,131.431,12.668,126.68,18.474,126.68z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A26234"
    },
    d: "M504.082,226.969v168.907h-5.278c-58.273,0-105.567,44.866-105.567,100.289H113.485 c0-55.423-47.294-100.289-105.567-100.289V226.969c58.273,0,105.567-44.866,105.567-100.289h279.753 c0,55.423,47.294,100.289,105.567,100.289H504.082z M324.619,221.691v-47.505H187.381v47.505H324.619z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8B542A"
    },
    d: "M187.381,221.691v-47.505H256V126.68H113.485c0,55.423-47.294,100.289-105.567,100.289v168.907 c58.273,0,105.567,44.866,105.567,100.289H256V221.691H187.381z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.381,
    y: 174.186,
    style: {
      fill: "#C8CDCF"
    },
    width: 137.237,
    height: 26.392
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.99,
    y: 15.835,
    style: {
      fill: "#937958"
    },
    width: 190.021,
    height: 21.113
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M493.526,118.763h-160.99V65.979h26.392V7.918H153.072v58.062h26.392v52.784H18.474C8.288,118.763,0,127.051,0,137.237 v348.371c0,10.186,8.288,18.474,18.474,18.474h475.052c10.186,0,18.474-8.288,18.474-18.474V137.237 C512,127.051,503.712,118.763,493.526,118.763z M496.165,137.237v81.78c-49.827-1.257-90.461-37.995-94.648-84.419h92.009 C494.956,134.598,496.165,135.807,496.165,137.237z M496.165,234.855V387.99c-58.583,1.282-106.337,45.1-110.54,100.257H121.097 c-4.077-53.49-49.112-96.313-105.262-100.022V234.62c56.15-3.708,101.185-46.532,105.262-100.022h264.528 C389.828,189.755,437.582,233.573,496.165,234.855z M168.907,23.753h174.186v26.392H168.907V23.753z M195.299,65.979h121.402v52.784 H195.299V65.979z M18.474,134.598h86.731c-4.038,44.773-41.978,80.534-89.37,84.149v-81.509 C15.835,135.807,17.044,134.598,18.474,134.598z M15.835,485.608v-81.509c47.392,3.615,85.332,39.375,89.37,84.149H18.474 C17.044,488.247,15.835,487.039,15.835,485.608z M493.526,488.247h-92.009c4.187-46.424,44.821-83.161,94.648-84.419v81.78 C496.165,487.039,494.956,488.247,493.526,488.247z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M179.464,229.608h153.072v-63.34H179.464V229.608z M195.299,182.103h121.402v31.67H195.299V182.103z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 176.825,
    y: 250.722,
    style: {
      fill: "#FFFFFF"
    },
    width: 84.454,
    height: 15.835
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.062,
    y: 250.722,
    style: {
      fill: "#FFFFFF"
    },
    width: 21.113,
    height: 15.835
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.113,
    y: 250.722,
    style: {
      fill: "#FFFFFF"
    },
    width: 21.113,
    height: 15.835
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.309,
    y: 155.711,
    style: {
      fill: "#FFFFFF"
    },
    width: 21.113,
    height: 15.835
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.309,
    y: 451.299,
    style: {
      fill: "#FFFFFF"
    },
    width: 21.113,
    height: 15.835
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.577,
    y: 451.299,
    style: {
      fill: "#FFFFFF"
    },
    width: 21.113,
    height: 15.835
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.577,
    y: 155.711,
    style: {
      fill: "#FFFFFF"
    },
    width: 21.113,
    height: 15.835
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio);
export default __webpack_public_path__ + "static/media/portfolio.ddaa43d8c5897670a43dae45c37b44a5.svg";
export { ForwardRef as ReactComponent };